// extracted by extract-css-chunks-webpack-plugin
module.exports = {"page_menu":"css-Z-D5jlwySN","page_menu_link":"css-lkCo4HL2GG","page_menu_link__active":"css-VNjtFLt8cr","page_inner__withMenu":"css-135HjatEBd"};